import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../utils/redux/store.tsx";
import _ from "lodash";

export const selectTimeSchedules = createSelector(
  [(state: RootState) => state.menuData.time_schedules],
  (timeSchedules) => _.keyBy(timeSchedules, "id")
);
